import React, { useEffect, useState } from "react";
import { PaymentOffer } from "../PaymentOffer/PaymentOffer";
import styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import { fetchOffer } from "../../../../shared/store/payment/actions";
import { useAppDispatch } from "../../../../shared/store";
import { useAppSelector } from "../../../../shared/store";
import { UnsuccessVerificationForm } from "../UnsuccessVerificationForm";
import { Waiting } from "../Waiting";
import { SuccessOfferDetail } from "../SuccessOfferDetail";
import { CheckPayment } from "../CheckPayment";
import { IOffer } from "../../../../shared/store/payment/types";
import { VerifWaiting } from "../VerifWaiting";
import { VerificationNeedForm } from "../VerificationNeedForm";
import { BanDetail } from "../BanDetail";
import { PaymentCancel } from "../PaymentCancel";
import { formTypeVariant } from "./types";
import { PageLoader } from "../PageLoader";
import { DepositeForm } from "../DepositeForm";
import { PaymentCancelVideoReport } from "../PaymentCancelVideoReport";
import { WaitingAmountChoice } from "../WaitingAmountChoice";
import { ClarifyCardNum } from "../ClarifyCardNum";
import { CardNumVerification } from "../CardNumVerification";
import { CardPhotoVerification } from "../CardPhotoVerification";
import { AwaitingRequisites } from "../AwaitingRequisites";

// Числа = backend OfferStatus (int). 23 = CARD_PHOTO_VERIFICATION (фаза B).
// 21/22 = ожидание подбора реквизитов (пустой пул трейдеров).
const PAYMENT__STATUSES = [
  2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
];

const getFormName = (offerData: IOffer) => {
  return {
    2: "takePayment",
    3: "successPayment",
    4: "unsuccessPaymenForm",
    5: "waiting",
    6: "paymentCancel",
    10: "paymentCancel",
    12: "paymentCancelWithoutPdf",
    14: "paymentCancel",
    16: "paymentCancelWithoutPdf",
    17: "paymentCancelVideoReport",
    7: "checkPayment",
    8: offerData.alreadyUploadedProof
      ? "verifWaitingUploadProofResult"
      : "verifWaitingUploadProof",
    9: offerData.alreadyUploadedProof
      ? "verifWaitingUploadProofResult"
      : "verifWaitingUploadProof",
    11: "banDetail",
    15: "chooseProvider",
    18: "waitingAmountChoice",
    19: "clarifyCardNum",
    20: "cardNumVerification",
    21: "awaitingRequisites",
    22: "awaitingRequisites",
    23: "cardPhotoVerification",
  }[offerData.status];
};

export const Payment = () => {
  const { offerId } = useParams();
  const [isFerstRequest, setRequsetStatus] = useState(true);
  const offerData = useAppSelector((state) => state.payment.offer);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isFerstRequest && offerId) {
      dispatch(fetchOffer(offerId));
      setRequsetStatus(false);
    }
    const offerRequest = setInterval(() => {
      if (offerId) {
        dispatch(fetchOffer(offerId));
      }
    }, 1000);
    return () => {
      clearInterval(offerRequest);
    };
  }, []);

  const forms = {
    paymentCancelVideoReport: (
      <PaymentCancelVideoReport
        attachFile={true}
        operatorComment={offerData?.traderComment}
      />
    ),
    takePayment: <PaymentOffer />,
    successPayment: <SuccessOfferDetail />,
    unsuccessPaymenForm: <UnsuccessVerificationForm />,
    waiting: <Waiting />,
    checkPayment: <CheckPayment />,
    verifWaitingUploadProofResult: <VerifWaiting />,
    verifWaitingUploadProof: <VerificationNeedForm />,
    banDetail: <BanDetail />,
    paymentCancel: <PaymentCancel attachFile={false} cardNumber={false} />,
    chooseProvider: <DepositeForm />,
    paymentCancelWithoutPdf: (
      <PaymentCancel
        attachFile={false}
        descriptionText={false}
        cardNumber={false}
      />
    ),
    waitingAmountChoice: <WaitingAmountChoice />,
    clarifyCardNum: <ClarifyCardNum />,
    cardNumVerification: <CardNumVerification />,
    cardPhotoVerification: <CardPhotoVerification />,
    awaitingRequisites: <AwaitingRequisites />,
  };

  const getForm = (offerData: IOffer) => {
    const formName = getFormName(offerData) as formTypeVariant;

    return forms[formName];
  };

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        {offerData && PAYMENT__STATUSES.includes(offerData.status) ? (
          getForm(offerData)
        ) : (
          <PageLoader />
        )}
      </div>
    </section>
  );
};
